import { useDynamicUI } from '@hooks/useDynamicUI';
import { PaymentRounded } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Stack,
    Typography,
} from '@mui/material';
import { createElement } from 'react';
import { useTranslation } from 'react-i18next';
import UpdatePaymentMethod from './UpdatePaymentMethod';

const PaymentMethod = ({ paymentMethod }) => {
    const { t } = useTranslation();
    const openUiElement = useDynamicUI();

    const openUpdatePaymentMethod = () => {
        openUiElement(onClose =>
            createElement(UpdatePaymentMethod, { open: true, onClose }),
        );
    };

    if (!paymentMethod) return null;

    return (
        <Card sx={{ flex: 1, p: 2 }}>
            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    alignItems: 'start',
                }}
            >
                <Typography
                    variant="labelLargeProminent"
                    textTransform="uppercase"
                    color="GrayText"
                >
                    {t('Payment Method')}
                </Typography>
                <Box
                    display="flex"
                    borderColor="outline.main"
                    borderRadius={4}
                    p={2}
                    sx={{
                        gap: 2,
                        width: '100%',
                        borderStyle: 'solid',
                        borderWidth: 1,
                        bgcolor: 'surfaceContainerLowest.main',
                    }}
                >
                    <Avatar
                        variant="roundedXSmall"
                        sx={{ bgcolor: 'surfaceContainerLow.main' }}
                    >
                        <PaymentRounded color="primary" />
                    </Avatar>
                    <Stack>
                        <Typography variant="titleMedium" fontWeight={500}>
                            {t('payment_method_card', {
                                brand: paymentMethod.type.value,
                                last4: paymentMethod.last4,
                            })}
                        </Typography>
                        <Typography variant="bodySmall" color="text.secondary">
                            {t('Expires')} {paymentMethod.expiry_month}/
                            {paymentMethod.expiry_year}
                        </Typography>
                    </Stack>
                    <Button
                        onClick={openUpdatePaymentMethod}
                        variant="text"
                        sx={{ ml: 'auto' }}
                    >
                        {t('Edit')}
                    </Button>
                </Box>
                {/* <Button variant="text" startIcon={<AddRounded />}>
                    {t('Add Payment Method')}
                </Button> */}
            </CardContent>
        </Card>
    );
};

export default PaymentMethod;
